import { theme } from '@acorns/grove'
import { Page as BasePage, ActionStripV2 } from '@acorns/web-components'
import styled from 'styled-components'

export const Page = styled(BasePage)<{ image: string }>`
  color: ${theme.colors.primaryWhite};
  background-color: ${theme.colors.naturalDarkOak};
  padding-bottom: 20px;
  top: 66px;

  > div {
    justify-content: center;
    padding-top: 0;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-top: 30px;
    background-color: unset;
    top: unset;

    #page-card {
      padding: 80px 80px 54px;
      background-color: ${theme.colors.naturalDarkOak};
      background-repeat: no-repeat;
      background-position: right bottom;
      background-image: url(${(props) => props.image});

      > div {
        margin: unset;
        padding: unset;

        > div {
          max-width: unset;
        }
      }
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column;
  margin-bottom: 10px;
`

export const Headline = styled.p`
  font-weight: 600;
  font-size: 30px;
  line-height: 41px;
  margin-top: 0;
  margin-bottom: 10px;
`

export const Subtitle = styled.p`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const BodyContainer = styled.div`
  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    width: 315px;
  }
`

export const FooterContainer = styled.div`
  margin-top: 30px;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    width: 315px;
  }
`

export const FooterTextContainer = styled.div`
  color: ${theme.colors.primaryWhite};
  font-style: italic;
  font-size: 10px;
  line-height: 16px;
`

export const ButtonContainer = styled.div`
  width: 100%;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    padding: 0;
    width: 220px;
  }
`

export const ActionStrip = styled(ActionStripV2)`
  position: static;
  padding: 0;
  margin-bottom: 30px;

  &:before {
    display: none;
  }
`

export const Image = styled.img`
  margin-bottom: 20px;
`
